<template>
  <q-dialog v-model="show" persistent>
    <q-card class="bg-white text-black reveal-dialog" style="min-width: 320px; max-width: 500px; width: 100%;">
      <q-card-section class="text-center q-pb-none q-pt-xl">
        <q-icon name="lock_open" color="primary" size="4.5rem" class="q-mb-md" />
        <div class="text-h5 text-weight-bold text-black">
          {{ $t('userPanel.apiIntegrations.reveal.title') }}
        </div>
      </q-card-section>

      <q-card-section class="q-pa-lg text-center">
        <p class="text-body2 text-grey-8">
          {{ $t('userPanel.apiIntegrations.reveal.message') }}
        </p>

        <!-- Key display box -->
        <div class="key-reveal-container q-my-lg q-pa-md bg-grey-2 rounded-borders flex flex-col items-center justify-center">
          <span class="api-key-monospace select-all q-mb-sm text-center">{{ plainKey }}</span>
          <q-btn
            color="primary"
            flat
            round
            icon="content_copy"
            size="md"
            @click="copyKeyToClipboard"
          >
            <q-tooltip>{{ $t('dashboard.sharesTable.copy') }}</q-tooltip>
          </q-btn>
        </div>

        <!-- Key warning info -->
        <div class="warning-callout q-pa-md rounded-borders bg-orange-1 flex no-wrap items-start text-left q-mt-md">
          <q-icon name="warning" color="warning" size="20px" class="q-mr-sm q-mt-xs" />
          <div>
            <div class="text-subtitle2 text-weight-bold text-warning">{{ $t('userPanel.apiIntegrations.reveal.securityWarning') }}</div>
            <div class="text-caption text-grey-8 q-mt-xs">
              {{ $t('userPanel.apiIntegrations.reveal.warning') }}
            </div>
          </div>
        </div>
      </q-card-section>

      <q-card-actions align="center" class="q-pb-xl q-px-lg">
        <q-btn
          color="primary"
          unelevated
          class="full-width q-py-sm text-weight-bold text-white close-reveal-btn"
          :label="$t('userPanel.apiIntegrations.reveal.closeButton')"
          @click="handleClose"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { notifySuccess, notifyError } from "@/utils/notify";

export default {
  name: "ApiIntegrationKeyRevealDialog",
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    plainKey: {
      type: String,
      required: true
    }
  },
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    }
  },
  methods: {
    async copyKeyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.plainKey);
        notifySuccess('userPanel.apiIntegrations.reveal.copied');
      } catch (err) {
        notifyError('userPanel.apiIntegrations.reveal.copyFailed');
      }
    },
    handleClose() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.reveal-dialog {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.key-reveal-container {
  border: 1px dashed rgba($primary, 0.4);
  background-color: #f9f9f9;
}

.api-key-monospace {
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.95rem;
  font-weight: bold;
  color: #fb2056;
  word-break: break-all;
  letter-spacing: 0.5px;
}

.select-all {
  user-select: all;
  -webkit-user-select: all;
}

.warning-callout {
  border: 1px solid rgba($warning, 0.2);
  background-color: rgba($warning, 0.05);
}

.close-reveal-btn {
  border-radius: 8px;
}
</style>
